import {Routes} from '@angular/router';
import {CommonWizardComponent} from './common-wizard.component';

export const commonRoutes: Routes = [
  {
    path: 'common',
    component: CommonWizardComponent,
  },
];
